import "./Footer.css";

export default function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <span>&copy; {new Date().getFullYear()} Carrosserie Kris</span>
        <span className="divider">|</span>
        <a href="./voorwaarden.pdf">Algemene Voorwaarden</a>
        <span className="divider">|</span>
        <a href="./privacy.pdf">Privacy Policy</a>
        <span className="divider">|</span>
        <span>BE 0687.810.469</span>
      </div>
      <div className="footer-credit">
        Website gemaakt door{" "}
        <a href="https://brentweb.eu" target="_blank" rel="noopener noreferrer">
          BrentWeb.eu
        </a>
      </div>
    </footer>
  );
}
